module.exports = __webpack_public_path__ + "img/imiwin-support.4aceede7.png";